import { render, staticRenderFns } from "./TicketSuporteSistema.vue?vue&type=template&id=7449717c&"
import script from "./TicketSuporteSistema.vue?vue&type=script&lang=js&"
export * from "./TicketSuporteSistema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports